// extracted by mini-css-extract-plugin
module.exports = {"TotalPrice":"CompleteShopping_TotalPrice__v5XQ7"};